import discountCheck from '@library/images/icons/discount-check.svg'
import progressIcon from '@library/images/icons/progressIcon.svg'

export default function CongratsCard({ text, isWarning = false }) {
    return (
        <div className={`flex ${isWarning ? 'bg-[#FFFAEB]' : 'bg-[#F6FFED]'} items-center gap-2 p-2`}>
            <img src={isWarning ? progressIcon : discountCheck} alt='discount check' width={48} height={48} />
            <div className='flex flex-col justify-center gap-1'>
                <p className={`flex items-center font-semibold ${isWarning ? 'text-[#9C6418]' : 'text-[#135200]'}`}>
                    {isWarning ? 'Button Addition pending at Gokwik' : 'Congratulations'}
                </p>
                <p className='font-inter font-semibold text-[16px] leading-[24px]'>{text}</p>
            </div>
        </div>
    )
}